module.exports = __webpack_public_path__ + "static/media/pic04.889b8ed9.webp";